import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { DivisionResponse } from "~types/division.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect.tsx";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  conferenceId?: string;
};

export const SelectDivision = ({ value, conferenceId, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: DivisionResponse) => {
    return (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.divisionId }));
  };

  const url = conferenceId ? `${sport}/o/${organizationId}/conferences/${conferenceId}/divisions` : "";

  return (
    <InfinitySelect<DivisionResponse>
      {...props}
      url={url}
      searchParameter="nameLocalContains"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.DIVISION}
      permissionOperation={PermissionOperations.READ}
      resetOptionsDependencies={[conferenceId]}
    />
  );
};
